/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Before_4Inputs */

const en_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No idea why you're not getting callbacks`)
};

const de_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ahnung, warum keine Rueckmeldungen kommen`)
};

const fr_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune idée de pourquoi tu ne reçois pas de retours`)
};

const es_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin idea de por qué no te llaman`)
};

const it_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna idea del perché non ricevi risposte`)
};

const nl_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen idee waarom je geen reacties krijgt`)
};

const pl_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak pojęcia, dlaczego nie dostajesz odpowiedzi`)
};

const fi_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei hajuakaan, miksi soittopyyntöjä ei tule`)
};

const da_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen idé om, hvorfor du ikke bliver ringet op`)
};

const sv_landing_before_4 = /** @type {(inputs: Landing_Before_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aning om varför du inte får svar`)
};

/**
* | output |
* | --- |
* | "No idea why you're not getting callbacks" |
*
* @param {Landing_Before_4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_before_4 = /** @type {((inputs?: Landing_Before_4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Before_4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_before_4(inputs)
	if (locale === "fr") return fr_landing_before_4(inputs)
	if (locale === "es") return es_landing_before_4(inputs)
	if (locale === "it") return it_landing_before_4(inputs)
	if (locale === "nl") return nl_landing_before_4(inputs)
	if (locale === "pl") return pl_landing_before_4(inputs)
	if (locale === "fi") return fi_landing_before_4(inputs)
	if (locale === "da") return da_landing_before_4(inputs)
	if (locale === "sv") return sv_landing_before_4(inputs)
	return en_landing_before_4(inputs)
});